import { Icon } from '@iconify/react';
import dayjs from 'dayjs';
import React, { useState } from 'react';
import { ICreateInvoiceData, ItemInput } from '../../../../@types';
import { InfoCircle } from '../../../../assets/icons/InfoCircle';
import InfoIcon from '../../../../assets/icons/InfoIcon';
import PlusBoxIcon from '../../../../assets/icons/PlusBoxIcon';
import { getInvoice } from '../../../../backend-services';
import { INVOICE_TABLE_HEADER } from '../../../../constants';
import { InvoiceValidationErrors } from '../../../../modules/invoice/invoice';
import useLineItems from '../../../../modules/lineItem';
import { InvoiceErrors } from '../../../../modules/validateInvoiceForm';
import { clearFieldError } from '../../../../utils/handleErrors';
import { ImportantCard } from '../../../common/TooltipCards/ImportantCard';
import { LineItemTable, TableColumn } from '../../../common/LineItemTable';
import { MiniCard } from '../../../common/TooltipCards/miniCards';
import CreateInventory from '../../../inventory/Create/CreateInventory';


interface InvoiceItemDetailsProps {
  formData: ICreateInvoiceData;
  updatedNewItem?: ItemInput;
  setFormData: React.Dispatch<React.SetStateAction<ICreateInvoiceData>>;
  invoiceNo?: string;
  validationResults: InvoiceErrors;
  setValidationResults: React.Dispatch<React.SetStateAction<InvoiceErrors>>;
}

const InvoiceItemDetails: React.FC<InvoiceItemDetailsProps> = ({
  formData,
  setFormData,
  invoiceNo,
  validationResults,
  setValidationResults,
}) => {
  const columns: TableColumn[] = INVOICE_TABLE_HEADER;
  const [showNewInventoryModal, setShowNewInventoryModal] = React.useState<boolean>(false);
  const [calcTax, setCalcTax] = React.useState(0);
  const [isMiniCardNewInventoryVisible, setIsMiniCardNewInventoryVisible] = useState(false);
  const [calcDiscount, setCalcDiscount] = React.useState(0);
  const { items, addItem, removeItem, updateCell, updateRow } = useLineItems([
    { id: '', name: '', rate: 0, quantity: 0 },
  ]);
  const handleCreateInventory = (inventory: any) => {
    addItem();
    updateRow(items.length - 1, inventory);
  };

  React.useEffect(() => {
    clearFieldError('inventories', validationResults, setValidationResults);
    setFormData((prevState: ICreateInvoiceData) => {
      return {
        ...prevState,
        inventories: items,
      };
    });
  }, [items]);

  React.useEffect(() => {
    const fetchInvoiceData = async () => {
      try {
        if (invoiceNo) {
          const response = await getInvoice(invoiceNo);
          if (response.inventories) {
            setFormData((prevState) => ({
              ...prevState,
              invoiceNumber: response.invoiceNumber,
              discount: response.discount ? response.discount * 100 : 0,
              tax: response.tax ? response.tax * 100 : 0,
              invoiceDueAt: dayjs(response.invoiceDueAt).format('YYYY-MM-DD'),
              inventories: response.inventories.map(
                (item: { name: string; id: string; quantity: number; rate: number }) => ({
                  name: item.name,
                  id: item.id,
                  quantity: item.quantity,
                  rate: item.rate,
                }),
              ),
              additionalInformation: response.additionalInformation,
              description: response.description,
            }));
            setCalcTax(response.tax);
            setCalcDiscount(response.discount);

            // Populate form data with customer name from URL parameter
            const urlParams = new URLSearchParams(window.location.search);
            const customerName = urlParams.get('customerName');
            if (customerName) {
              setFormData((prevState) => ({
                ...prevState,
                name: customerName,
              }));
            }
          }
        }
      } catch (error) {
        // Handle error case
      }
    };

    fetchInvoiceData();
  }, [invoiceNo]);

  const [draftValidationResults, setDraftValidationResults] = React.useState<InvoiceValidationErrors>({
    customerId: undefined,
    invoiceNumber: undefined,
    invoiceDueAt: '',
    description: undefined,
    status: undefined,
    issueDate: undefined,
    additionalInformation: undefined,
    shippingCharge: undefined,
    discount: undefined,
    tax: undefined,
    isReoccurring: undefined,
    isReoccurringStartDate: undefined,
    isReoccurringEndDate: undefined,
    reoccurringGroupName: undefined,
    task: undefined,
    inventories: undefined,
    currency: undefined,
    exchangeRate: undefined,
  });

  

  const handleInfoCircleNewInventoryHover = () => {
    setIsMiniCardNewInventoryVisible(true);
  };

  const handleInfoCircleNewInventoryMouseLeave = () => {
    setIsMiniCardNewInventoryVisible(false);
  };

  return (
    <div>
      <h2 className="xl:text-[24px] text-center mt-[1em]">Fill in Details About the Items</h2>
      <div className=" flex justify-center">
        <div className="mt-[2em]">
          <LineItemTable
            columns={columns}
            items={formData.inventories}
            isSearchInput={true}
            addItem={addItem}
            removeItem={removeItem}
            updateCell={updateCell}
            updateRow={updateRow}
            isImportedToInvoice={false}
          />
          <a
            href="/inventories/create"
            className="inline-flex justify-start text-[#044E97] font-medium mt-[-3em]  xl:mt-[-1em] xl:pl  lg:text-[16px] md:text-[14px] text-[12px]  "
            onClick={() => setShowNewInventoryModal(true)}
          >
            Add New Inventory
            <span className="xl:mt-[0.2em] biglg:mt-[0.2em] ml-[0.3em] ">
              <PlusBoxIcon />
            </span>
          </a>
          <div className="">
            {(validationResults.inventories || draftValidationResults.inventories) && (
              <span className="text-red-500 ">
                {validationResults.inventories || draftValidationResults.inventories}
              </span>
            )}
          </div>
          {/* <CreateInventory
            onCreateInventory={handleCreateInventory}
            show={showNewInventoryModal}
            onClose={() => setShowNewInventoryModal(false)}
          /> */}
        </div>
      </div>
    </div>
  );
};

export default InvoiceItemDetails;
